// test76
(76 && 0);
